/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Guided_TitleInputs */

const en_mk_build_guided_title = /** @type {(inputs: Mk_Build_Guided_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guided`)
};

const id_mk_build_guided_title = /** @type {(inputs: Mk_Build_Guided_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didampingi`)
};

/**
* | output |
* | --- |
* | "Guided" |
*
* @param {Mk_Build_Guided_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_guided_title = /** @type {((inputs?: Mk_Build_Guided_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Guided_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_guided_title(inputs)
	return en_mk_build_guided_title(inputs)
});